// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ya4A","top":"styles_top__3CwOu"};